// extracted by mini-css-extract-plugin
export default {"container":"TagSnpModalV2__container___NEibW"};